// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e448face","627":"ecd0899c","653":"70d5af1c","738":"f398f043","923":"65a483fe","938":"c11c43d5"}[chunkId] + ".chunk.js";
};